import Truck from '@/models/Truck'
import User, { hasRole, Role } from '@/models/User'

export default class TruckPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, truck: Truck) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === truck.entry.catalog.company.id
			case Role.AUDITOR:
				return user.auditor?.id === truck.entry.catalog.auditor?.id
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, truck: Truck) {
		return hasRole(user, Role.USER) && user.company?.id === truck.entry.catalog.company.id
	}

	restore(user: User, truck: Truck) {
		return hasRole(user, Role.USER) && user.company?.id === truck.entry.catalog.company.id
	}

	delete(user: User, truck: Truck) {
		return hasRole(user, Role.USER) && user.company?.id === truck.entry.catalog.company.id
	}

	forceDelete(_user: User, _truck: Truck) {
		return false
	}
}
